/* Trust pillar drawers (sections/trust-pillar.liquid). Native <dialog>: focus trap, Esc and focus return
   come from the browser. Delegated from document, so it survives the theme editor re-rendering the section.
   The shipping estimate is the 2026 pillar's calculator: checkout's own weight bands, in the visitor's currency. */
(function () {
  if (window.__trustPillar) return;
  window.__trustPillar = true;
  var html = document.documentElement;

  function ev(name, p) {
    (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, p || {}));
  }
  function close(d) { if (d && d.open) d.close(); }

  /* Card text: fade only the ones that run past their lines */
  function fade(root) {
    (root || document).querySelectorAll('.tp__text').forEach(function (p) {
      p.classList.toggle('is-faded', p.scrollHeight > p.clientHeight + 1);
    });
  }
  var ro = 'ResizeObserver' in window ? new ResizeObserver(function () { fade(); }) : null;
  function watch(root) {
    fade(root);
    if (ro) (root || document).querySelectorAll('.tp__grid').forEach(function (g) { ro.observe(g); });
  }
  if (document.readyState !== 'loading') watch(); else document.addEventListener('DOMContentLoaded', function () { watch(); });
  window.addEventListener('load', function () { fade(); });
  document.addEventListener('shopify:section:load', function (e) { watch(e.target); carousels(e.target); });

  /* Phones: one promise at a time. Dots show where you are; it turns on its own every few seconds while in view,
     and stops for good at the first touch, tap, key or focus. Never for reduced motion. */
  var phone = window.matchMedia('(max-width: 767px)');
  var still = window.matchMedia('(prefers-reduced-motion: reduce)');
  function carousels(root) {
    (root || document).querySelectorAll('[data-trust-pillar]').forEach(function (sec) {
      var track = sec.querySelector('.tp__grid'), dotsEl = sec.querySelector('[data-tp-dots]');
      if (!track || !dotsEl || dotsEl.dataset.ready) return;
      dotsEl.dataset.ready = '1';
      var cells = [].slice.call(track.children), i = 0, timer = null, stopped = false, seen = false;
      var secs = +dotsEl.getAttribute('data-autoplay') || 0;
      cells.forEach(function (c, n) {
        var b = document.createElement('button');
        b.type = 'button';
        var k = c.querySelector('.tp__kicker');
        b.setAttribute('aria-label', (k ? k.textContent.trim() : '') + ' (' + (n + 1) + '/' + cells.length + ')');
        b.addEventListener('click', function () { stop(); go(n); });
        dotsEl.appendChild(b);
      });
      var dots = [].slice.call(dotsEl.children);
      function mark() { dots.forEach(function (d, n) { d.setAttribute('aria-current', String(n === i)); }); }
      /* Seamless loop (Marcus 2026-11-03): a copy of the first promise sits after the last. Past the last dot the
         track glides on to the copy and then lands, unseen, on the real first, instead of rewinding through all four.
         The copy is hidden from screen readers, takes no focus or taps, carries no drawer or id, and never shows on
         desktop (CSS). */
      var clone = cells[0].cloneNode(true);
      clone.classList.add('is-clone');
      clone.setAttribute('aria-hidden', 'true');
      clone.inert = true;
      clone.querySelectorAll('dialog').forEach(function (d) { d.remove(); });
      [clone].concat([].slice.call(clone.querySelectorAll('[id]'))).forEach(function (e) { e.removeAttribute('id'); });
      track.appendChild(clone);
      var busy = false, settle = null;
      function pos(k) { return (k < cells.length ? cells[k] : clone).offsetLeft - track.offsetLeft; }
      function step() { return Math.max(1, pos(1) - pos(0)); }
      function jump(x) { track.style.scrollSnapType = 'none'; track.scrollLeft = x; requestAnimationFrame(function () { track.style.scrollSnapType = ''; }); }
      /* A calm glide (ease in-out, 650 ms) instead of the browser's quick snap */
      function glide(to, done) {
        if (still.matches) { jump(to); if (done) done(); return; }
        var from = track.scrollLeft, t0 = null;
        busy = true;
        track.style.scrollSnapType = 'none';
        requestAnimationFrame(function frame(t) {
          if (t0 === null) t0 = t;
          var p = Math.min(1, (t - t0) / 650), e = p < .5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
          track.scrollLeft = from + (to - from) * e;
          if (p < 1) return requestAnimationFrame(frame);
          track.style.scrollSnapType = '';
          busy = false;
          if (done) done();
        });
      }
      function go(n) {
        var last = i === cells.length - 1 && n === cells.length;
        i = (n + cells.length) % cells.length;
        mark();
        if (last) glide(pos(cells.length), function () { jump(pos(0)); });
        else glide(pos(i));
      }
      track.addEventListener('scroll', function () {
        if (busy) return;
        var n = Math.round(track.scrollLeft / step());
        if (n % cells.length !== i) { i = n % cells.length; mark(); }
        /* A swipe that ends on the copy lands on the real first */
        clearTimeout(settle);
        settle = setTimeout(function () { if (!busy && track.scrollLeft >= pos(cells.length) - 2) jump(track.scrollLeft - pos(cells.length) + pos(0)); }, 140);
      }, { passive: true });
      function stop() { stopped = true; clearInterval(timer); timer = null; }
      ['pointerdown', 'touchstart', 'keydown', 'focusin', 'wheel'].forEach(function (t) { track.addEventListener(t, stop, { passive: true }); });
      function run() {
        clearInterval(timer); timer = null;
        if (stopped || !secs || !phone.matches || still.matches || !seen || document.hidden) return;
        if (document.querySelector('.tp-d[open]')) return;
        timer = setInterval(function () { if (!document.querySelector('.tp-d[open]')) go(i + 1); }, secs * 1000);
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { seen = es[0].isIntersecting; run(); }, { threshold: .6 }).observe(track);
      }
      document.addEventListener('visibilitychange', run);
      if (phone.addEventListener) phone.addEventListener('change', run);
      mark();
    });
  }
  if (document.readyState !== 'loading') carousels(); else document.addEventListener('DOMContentLoaded', function () { carousels(); });

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-tp-open]');
    if (open) {
      var d = document.getElementById(open.getAttribute('data-tp-open'));
      if (!d || typeof d.showModal !== 'function') return;
      d.showModal();
      html.style.overflow = 'hidden';
      ship(d);
      var root = open.closest('[data-trust-pillar]');
      ev('know_detail_open', { anchor: open.getAttribute('data-tp-open'), pillar: root && root.getAttribute('data-pillar') });
      return;
    }
    var dlg = e.target.closest('[data-tp-dialog]');
    if (!dlg) return;
    if (e.target === dlg || e.target.closest('[data-tp-close]')) { close(dlg); return; }
    var act = e.target.closest('[data-tp-act]');
    if (act) { close(dlg); } /* the link's own #find or #shop does the rest */
  });
  document.addEventListener('close', function (e) {
    if (e.target.matches && e.target.matches('[data-tp-dialog]')) html.style.overflow = '';
  }, true);

  function ship(d) {
    var el = d.querySelector('[data-tp-ship]');
    if (!el || el.dataset.ready) return;
    el.dataset.ready = '1';
    var src = d.closest('[data-trust-pillar]');
    var dataEl = src && src.querySelector('[data-tp-ship-data]');
    var SH; try { SH = JSON.parse(dataEl.textContent); } catch (err) { return; }
    if (!SH || !SH.zones) return;
    var country = el.getAttribute('data-country'), zone = null;
    SH.zones.forEach(function (z) { if (z.countries.indexOf(country) > -1) zone = z; });
    var cur = (window.Shopify && Shopify.currency) || {}, active = cur.active, rate = parseFloat(cur.rate) || 1;
    if (!zone || !(zone.currency === active || zone.currency === 'EUR')) return;
    var n = 2, sel = el.querySelector('[data-tp-ship-model]'), out = el.querySelector('[data-tp-ship-price]'),
      nEl = el.querySelector('[data-tp-ship-n]'), note = el.querySelector('.tp-d__fine');
    function money(v) {
      var whole = Math.abs(v - Math.round(v)) < .005;
      try { return new Intl.NumberFormat(html.lang || 'en', { style: 'currency', currency: active, minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 }).format(v); }
      catch (err) { return v.toFixed(2) + ' ' + active; }
    }
    function calc() {
      var kg = (SH.weights[sel.value] || 7) * n, price = null;
      for (var i = 0; i < zone.bands.length; i++) { var b = zone.bands[i]; if (b[0] === null || kg <= b[0] + 1e-9) { price = b[1]; break; } }
      if (price === null) return;
      var shopCur = SH.shop_currency || 'EUR', about = zone.currency !== shopCur, v;
      if (zone.currency === active && !about) v = price;
      else if (zone.currency === active) v = Math.round(price * (SH.fx_fee || 1) * 100) / 100; /* checkout converts via EUR */
      else v = Math.round(price * rate * 100) / 100; /* EUR zone in another currency: exact */
      nEl.textContent = n;
      out.textContent = about ? note.getAttribute('data-about-fmt').replace('%p', money(v)) : money(v);
      note.textContent = about ? note.getAttribute('data-about') : note.getAttribute('data-exact');
    }
    sel.addEventListener('change', calc);
    el.querySelectorAll('[data-tp-ship-step]').forEach(function (b) {
      b.addEventListener('click', function () { n = Math.min(12, Math.max(1, n + +b.getAttribute('data-tp-ship-step'))); calc(); });
    });
    calc();
    el.hidden = false;
  }
})();
